import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import type { ServiceWorkerConfig } from 'owa-serviceworker-common/lib/types/ServiceWorkerConfig';

export const getServiceWorkerConfig = (): ServiceWorkerConfig => {
    if (isMiniHostAppFeatureEnabled('nativeServiceWorker')) {
        return {
            app: 'miniNative',
            expectedXAppNameHeader: 'miniNative',
        };
    } else {
        return {
            app: 'miniApp',
            expectedXAppNameHeader: 'miniApp',
        };
    }
};
